import React from 'react';
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCheckCircle,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const PassportVisaDetails = () => {
  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                  <h5 className="widget-title">
                    <FaArrowRight /> All Service lists
                  </h5>
                  <ul className="catagory-items">
                    <li>
                      <Link to="/AirTicketing"> Air Ticketing</Link>
                    </li>
                    <li>
                      <Link to="/TravelInsurance"> Travel Insurance</Link>
                    </li>
                    <li>
                      <Link to="/DomesticInternationalTours"> Domestic & International Tours</Link>
                    </li>
                     <li>
                      <Link to="/MICE"> MICE</Link>
                     </li>
                    <li>
                      <Link to="/PassportVisa"> Passport & Visa Assistance</Link>
                    </li>
                    <li>
                       <Link to="/HotelBooking"> Hotel Booking </Link>
                     </li>
                  </ul>
                </div>
                <div className="widget widget_author text-center">
                  <div className="thumb">
                    <img src="assets/img/about/9.png" alt="img" />
                  </div>
                  
                </div>
               
              </div>
            </div>
            <div className="col-lg-8">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  <div className="thumb">
                    <img src="assets/img/banner6.jpg" alt="img" />
                  </div>
                  <div className="details">
                    <h4>
                    Smooth & Hassle-Free Passport and Visa Services
                    </h4>
                    <p>
                    Applying for a passport or visa can be time-consuming. Let our experts handle
                     the paperwork for you. We assist with fresh
                     passport applications, renewals, and visa processing for major countries.
                    </p>
                   
                  
                    <h4>Services Offered:</h4>
                   
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle />New Passport & Renewal
                          </li>
                          <li>
                            <FaCheckCircle /> Tourist, Business & Transit Visas
                          </li>
                          <li>
                            <FaCheckCircle /> Documentation Assistance
                          </li>
                          <li>
                            <FaCheckCircle /> Interview Preparation (if required)
                          </li>
                         
                        </ul>
                      </div>

                      <div className="details">
                    <Link className="btn btn-base border-radius-5" to="tel:6363169466">
                    Fast & Reliable Document Services at Your Fingertips!
                    </Link>
                  </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default PassportVisaDetails;
